import { DebtorSagas } from "./Debtor"
import { ChangeDebtorSagas } from "./ChangeDebtor"
import { DuplicateDebtorsSagas } from "./DuplicateDebtors"
import { AdditionalInformationSagas } from "./AdditionalInformation"

export default [
    ...DebtorSagas,
    ...ChangeDebtorSagas,
    ...DuplicateDebtorsSagas,
    ...AdditionalInformationSagas
]